$('.account--tab-link').on('click', function(e){
    e.preventDefault();

    $('.account--tab-link').removeClass('active-link');
    $(this).addClass('active-link');

    let tab = $(this).data('tab');
    $('.account--tab').hide();
    $('.account--tab[data-tab-content="'+tab+'"]').show();

	if (window.innerWidth < 1024) {
		$('html, body').animate({ scrollTop: 0 }, 200);
	}
});

$('body').on('click', '.open-lifer-tab', function(e) {
    e.preventDefault();
    $(this).closest('.lifer-tab').find('.lifer-tab--slide-info').toggle();
});

$('.lifer-model').on('change', function(e){
    e.preventDefault();

    if ($(this).val() == '') {
        $(this).addClass('select-empty');
    } else {
        $(this).removeClass('select-empty');
    }
});

$(".lifer_datepicker").datepicker({
    maxDate: '0',
    changeYear: true,
    yearRange: '-100:+0',
    changeMonth: true,
    dateFormat: "mm-dd-yy"
});

$('.rfield').on('input change', function () {
	$(this).addClass('was-touched');
	const form = $(this).closest('form');
	checkInput(form);
});


$('.rfield').on('blur', function () {
	$(this).addClass('was-touched');
	const form = $(this).closest('form');
	checkInput(form);
});

$('.lifer-register-btn').on('click', function(e){
    e.preventDefault();

    let form = $(this).closest('form');
	form.find('.rfield').addClass('was-touched');
    checkInput(form);

    let serialNum = form.find('#lifer__serial');
    // let checkSerialNum = validateSerialNumber(serialNum);
    let checkSerialNum = true;

    if (form.find('.empty_field').length == 0) {
        if (checkSerialNum == true) {
            registerLifer(form);
            $('.lifer-register-btn').prop('disabled', true);
        } else {
            if ($('.lifer-register-btn').hasClass('request-verification')) {
                registerLifer(form);
                $('.lifer-register-btn').prop('disabled', true);
            }

            $('.lifer-register-btn').attr('value', 'Request verification');
            $('.lifer-register-btn').addClass('request-verification');
        }
    }
});

$(function () {
    //getLifers();
});

$('body').on('click', '.lifer-add-btn', function(e) {
    e.preventDefault();

    $('.serial-message').html('').hide();
    $('.lifer-register-btn').attr('value', 'Register');
    $('.lifer-register-btn').removeClass('request-verification');

    $('.lifer-register').show();
    $('.lifer-register .lifer-tab--slide-info').show();
    $('.lifer-add-btn').attr('disabled', 'true');

});

$('body').on('click', '.lifer-update-btn', function(e) {
    e.preventDefault();

    let form = $(this).closest('form');
	form.find('.rfield').addClass('was-touched');
    checkInput(form);

    if ($(form).find('.empty_field').length == 0) {
        updateLifer(form);
    }
});

$('body').on('click', '.lifer-delete-btn', function(e) {
    e.preventDefault();

    let form = $(this).closest('form');

    if (confirm("Are you sure you want to delete lifer?") == true) {
        deleteLifer(form);
    }
});

$('.account-details__bikes h2').click(function () {
    $(this).toggleClass('open').next('.table-container').slideToggle();
});

function registerLifer(current_form) {
    let form = current_form[0];
    let formData = new FormData(form);

    let object = {};
    formData.forEach((value, key) => object[key] = value);
    let json = JSON.stringify(object);

    let actionUrl = window.theme.routes.shop_url.permanent_domain == 'early-rider-us.myshopify.com' || window.theme.routes.permanent_domain == 'liferbikes-test.myshopify.com' ? `${window.theme.routes.shop_url}/a/early-rider-preprod` : `${window.theme.routes.shop_url}/a/early-rider`;

    $.ajax({
        url: actionUrl + '/create-customer-lifer',
        type: 'POST',
        data: json,
        processData: false,
        contentType: false,
        success: function (result) {
            $('html, body').animate({
                scrollTop: $(".customer__content").offset().top
            }, 500);

            current_form.find('.lifer-input').val('');
            current_form.find('.lifer-tab--slide-info').slideToggle();

            $('.lifer-register').css('display', 'none');
            $('.lifer-add-btn').prop("disabled", false);

            $('.account--lifer').css('opacity', '0');
            $('.account--loading').show();

            $('.lifers').empty();
            getLifers();

            setTimeout(function () {
                $('.account--lifer').css('opacity', '1');
                $('.account--loading').hide();

                showFormMessage('Lifer created!', '#a3d16d');
                $('.lifer-register-btn').prop('disabled', false);
            }, 2000);
        },
        error: function (XMLHttpRequest, textStatus, result) {
            showFormMessage('Error. Lifer was not created.', 'red');
        }
    });
}

function updateLifer(current_form) {
    let form = current_form[0];
    let formData = new FormData(form);

    let object = {};
    formData.forEach((value, key) => object[key] = value);
    let json = JSON.stringify(object);

    let actionUrl = window.theme.routes.shop_url.permanent_domain == 'early-rider-us.myshopify.com' || window.theme.routes.permanent_domain == 'liferbikes-test.myshopify.com' ? `${window.theme.routes.shop_url}/a/early-rider-preprod` : `${window.theme.routes.shop_url}/a/early-rider`;

    $.ajax({
        url: actionUrl + `/update-customer-lifer`,
        type: 'POST',
        data: json,
        processData: false,
        contentType: false,
        success: function (result) {
            $('html, body').animate({
                scrollTop: $(".customer__content").offset().top
            }, 500);

            current_form.find('.lifer-tab--slide-info').toggle();

            $('.account--lifer').css('opacity', '0');
            $('.account--loading').show();

            $('.lifers').empty();
            getLifers();

            setTimeout(function () {
                $('.account--lifer').css('opacity', '1');
                $('.account--loading').hide();

                showFormMessage('Lifer updated!', '#a3d16d');
            }, 1000);
        },
        error: function (XMLHttpRequest, textStatus, result) {
            showFormMessage('Error. Lifer was not updated.', 'red');
        }
    });
}

function deleteLifer(current_form) {
    let actionUrl = window.theme.routes.shop_url.permanent_domain == 'early-rider-us.myshopify.com' || window.theme.routes.permanent_domain == 'liferbikes-test.myshopify.com' ? `${window.theme.routes.shop_url}/a/early-rider-preprod` : `${window.theme.routes.shop_url}/a/early-rider`;
    let liferId = current_form.find('#lifer__customer-id').attr('data-lifer-id');

    fetch(actionUrl+`/delete-customer-lifer/${window.theme.customer.id}/${liferId}`, {method: 'DELETE'}).then(response => response.json()).then(response => {
        current_form.hide();
        $('.lifer-add-btn').prop("disabled", false);
        $('.lifer-add-btn').show();
    });
}

function showFormMessage(text, color) {
    $('.form-message').text(text);
    $('.form-message').css('color', color);
    $('.form-message').slideDown(500);

    setTimeout(function () {
        $('.form-message').slideUp(500);
    }, 3000);
}

function checkInput(form){
	form.find('.rfield.was-touched').each(function () {
		if ($(this).val().trim() !== '') {
			$(this).removeClass('empty_field');
		} else {
			$(this).addClass('empty_field');
		}
	});
}

function getLifers() {
    let actionUrl = window.theme.routes.shop_url.permanent_domain == 'early-rider-us.myshopify.com' || window.theme.routes.permanent_domain == 'liferbikes-test.myshopify.com' ? `${window.theme.routes.shop_url}/a/early-rider-preprod` : `${window.theme.routes.shop_url}/a/early-rider`;
    let customerID = `${window.theme.customer.id}`;

    $.ajax({
        url: actionUrl + `/customer-lifers/${customerID}`,
        type: 'GET',
        success: function (result) {
            if (result.data.length > 0) { //Lifers found
                $.each(result.data, function(index, object) {
                    setLifer(object);
                });

                $.each( $('.lifer-account .lifer-country'), function() {
                    let selectedCountry = $(this).attr('data-value');
                    $(this).val(selectedCountry).change();
                });

                $('.lifer-register').hide();
                $('.lifers').find('.lifer-tab--slide-info').css('display', 'none');
            } else {
                $('.lifer-register').show();
                $('.lifer-add-btn').attr('disabled', 'true');
            }

            if (result.data.length == 5) {
                $('.lifer-add-btn').hide();
                $('.lifer-register').hide();
            }
        },
        error: function (XMLHttpRequest, textStatus, result) {
            //console.log('error');
        }
    });
}

function setLifer (object) {
    let form = $('<form class="lifer-tab lifer-account">');
    form.append('<div class="lifer-tab--block">' +
        '<div class="lifer-tab--title open-lifer-tab">'+object.first_name+' '+object.last_name+'</div>' +
        '<div class="lifer-tab--form lifer-tab--slide-info">' +
        `<input type="text" id="lifer__id" name="id" value="${object.id}" hidden="">` +
        `<input type="text" id="lifer__customer-id" name="customer_api_id" value="${object.customer_api_id}" data-lifer-id="${object.id}" hidden="">` +
        `<input type="text" id="lifer__first-name-${object.id}" name="first_name" value="${object.first_name}" required="" maxlength="150" class="lifer-input input-half rfield" placeholder="First name*">` +
        `<input type="text" id="lifer__last-name-${object.id}" name="last_name" value="${object.last_name}" required="" maxlength="150" class="lifer-input input-half rfield" placeholder="Last name*">` +
        `<input type="text" id="lifer__date-${object.id}" name="birthday"  value="${object.birthday}" placeholder="Date Of Birth*" class="lifer-input input-half rfield lifer_account-datepicker" autocomplete="off" readonly>` +
        `<input type="text" id="lifer__address-${object.id}" name="address" value="${object.address}" required="" maxlength="200" class="lifer-input input-full rfield" placeholder="Address*">` +
        `<input type="text" id="lifer__suburb-${object.id}" name="suburb" value="${object.suburb}" maxlength="200" class="lifer-input input-full" placeholder="Suburb (optional)">` +
        `<input type="text" id="lifer__city-${object.id}" name="city" value="${object.city}" required="" maxlength="100" class="lifer-input input-third rfield" placeholder="City*">` +
        `<input type="text" id="lifer__province-${object.id}" value="${object.province}" required="" name="province" maxlength="150" class="lifer-input input-third rfield" placeholder="Province*">` +
        `<input type="text" id="lifer__zip-${object.id}" value="${object.postcode}" required="" name="postcode" maxlength="50" class="lifer-input input-third rfield" placeholder="Postal code*">` +
        `<div class="select-wrapper input-full">` +
        `<span class="select-label">Country/region*</span>` +
        `<select id="lifer__country-${object.id}" data-value="${object.country}" name="country" required="" class="lifer-input lifer-country input-full rfield">
                                            <option value="United States">United States</option>
                                            <option value="United Kingdom">United Kingdom</option>
                                            <option value="Afghanistan">Afghanistan</option>
                                            <option value="Albania">Albania</option>
                                            <option value="Algeria">Algeria</option>
                                            <option value="American Samoa">American Samoa</option>
                                            <option value="Andorra">Andorra</option>
                                            <option value="Angola">Angola</option>
                                            <option value="Anguilla">Anguilla</option>
                                            <option value="Antarctica">Antarctica</option>
                                            <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                            <option value="Argentina">Argentina</option>
                                            <option value="Armenia">Armenia</option>
                                            <option value="Aruba">Aruba</option>
                                            <option value="Australia">Australia</option>
                                            <option value="Austria">Austria</option>
                                            <option value="Azerbaijan">Azerbaijan</option>
                                            <option value="Bahamas">Bahamas</option>
                                            <option value="Bahrain">Bahrain</option>
                                            <option value="Bangladesh">Bangladesh</option>
                                            <option value="Barbados">Barbados</option>
                                            <option value="Belarus">Belarus</option>
                                            <option value="Belgium">Belgium</option>
                                            <option value="Belize">Belize</option>
                                            <option value="Benin">Benin</option>
                                            <option value="Bermuda">Bermuda</option>
                                            <option value="Bhutan">Bhutan</option>
                                            <option value="Bolivia">Bolivia</option>
                                            <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                            <option value="Botswana">Botswana</option>
                                            <option value="Bouvet Island">Bouvet Island</option>
                                            <option value="Brazil">Brazil</option>
                                            <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                            <option value="Brunei Darussalam">Brunei Darussalam</option>
                                            <option value="Bulgaria">Bulgaria</option>
                                            <option value="Burkina Faso">Burkina Faso</option>
                                            <option value="Burundi">Burundi</option>
                                            <option value="Cambodia">Cambodia</option>
                                            <option value="Cameroon">Cameroon</option>
                                            <option value="Canada">Canada</option>
                                            <option value="Cape Verde">Cape Verde</option>
                                            <option value="Cayman Islands">Cayman Islands</option>
                                            <option value="Central African Republic">Central African Republic</option>
                                            <option value="Chad">Chad</option>
                                            <option value="Chile">Chile</option>
                                            <option value="China">China</option>
                                            <option value="Christmas Island">Christmas Island</option>
                                            <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                            <option value="Colombia">Colombia</option>
                                            <option value="Comoros">Comoros</option>
                                            <option value="Congo">Congo</option>
                                            <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                                            <option value="Cook Islands">Cook Islands</option>
                                            <option value="Costa Rica">Costa Rica</option>
                                            <option value="Cote D'ivoire">Cote D'ivoire</option>
                                            <option value="Croatia">Croatia</option>
                                            <option value="Cuba">Cuba</option>
                                            <option value="Cyprus">Cyprus</option>
                                            <option value="Czech Republic">Czech Republic</option>
                                            <option value="Denmark">Denmark</option>
                                            <option value="Djibouti">Djibouti</option>
                                            <option value="Dominica">Dominica</option>
                                            <option value="Dominican Republic">Dominican Republic</option>
                                            <option value="Ecuador">Ecuador</option>
                                            <option value="Egypt">Egypt</option>
                                            <option value="El Salvador">El Salvador</option>
                                            <option value="Equatorial Guinea">Equatorial Guinea</option>
                                            <option value="Eritrea">Eritrea</option>
                                            <option value="Estonia">Estonia</option>
                                            <option value="Ethiopia">Ethiopia</option>
                                            <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                            <option value="Faroe Islands">Faroe Islands</option>
                                            <option value="Fiji">Fiji</option>
                                            <option value="Finland">Finland</option>
                                            <option value="France">France</option>
                                            <option value="French Guiana">French Guiana</option>
                                            <option value="French Polynesia">French Polynesia</option>
                                            <option value="French Southern Territories">French Southern Territories</option>
                                            <option value="Gabon">Gabon</option>
                                            <option value="Gambia">Gambia</option>
                                            <option value="Georgia">Georgia</option>
                                            <option value="Germany">Germany</option>
                                            <option value="Ghana">Ghana</option>
                                            <option value="Gibraltar">Gibraltar</option>
                                            <option value="Greece">Greece</option>
                                            <option value="Greenland">Greenland</option>
                                            <option value="Grenada">Grenada</option>
                                            <option value="Guadeloupe">Guadeloupe</option>
                                            <option value="Guam">Guam</option>
                                            <option value="Guatemala">Guatemala</option>
                                            <option value="Guinea">Guinea</option>
                                            <option value="Guinea-bissau">Guinea-bissau</option>
                                            <option value="Guyana">Guyana</option>
                                            <option value="Haiti">Haiti</option>
                                            <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                                            <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                                            <option value="Honduras">Honduras</option>
                                            <option value="Hong Kong">Hong Kong</option>
                                            <option value="Hungary">Hungary</option>
                                            <option value="Iceland">Iceland</option>
                                            <option value="India">India</option>
                                            <option value="Indonesia">Indonesia</option>
                                            <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                                            <option value="Iraq">Iraq</option>
                                            <option value="Ireland">Ireland</option>
                                            <option value="Israel">Israel</option>
                                            <option value="Italy">Italy</option>
                                            <option value="Jamaica">Jamaica</option>
                                            <option value="Japan">Japan</option>
                                            <option value="Jordan">Jordan</option>
                                            <option value="Kazakhstan">Kazakhstan</option>
                                            <option value="Kenya">Kenya</option>
                                            <option value="Kiribati">Kiribati</option>
                                            <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                                            <option value="Korea, Republic of">Korea, Republic of</option>
                                            <option value="Kuwait">Kuwait</option>
                                            <option value="Kyrgyzstan">Kyrgyzstan</option>
                                            <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                            <option value="Latvia">Latvia</option>
                                            <option value="Lebanon">Lebanon</option>
                                            <option value="Lesotho">Lesotho</option>
                                            <option value="Liberia">Liberia</option>
                                            <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                                            <option value="Liechtenstein">Liechtenstein</option>
                                            <option value="Lithuania">Lithuania</option>
                                            <option value="Luxembourg">Luxembourg</option>
                                            <option value="Macao">Macao</option>
                                            <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                                            <option value="Madagascar">Madagascar</option>
                                            <option value="Malawi">Malawi</option>
                                            <option value="Malaysia">Malaysia</option>
                                            <option value="Maldives">Maldives</option>
                                            <option value="Mali">Mali</option>
                                            <option value="Malta">Malta</option>
                                            <option value="Marshall Islands">Marshall Islands</option>
                                            <option value="Martinique">Martinique</option>
                                            <option value="Mauritania">Mauritania</option>
                                            <option value="Mauritius">Mauritius</option>
                                            <option value="Mayotte">Mayotte</option>
                                            <option value="Mexico">Mexico</option>
                                            <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                            <option value="Moldova, Republic of">Moldova, Republic of</option>
                                            <option value="Monaco">Monaco</option>
                                            <option value="Mongolia">Mongolia</option>
                                            <option value="Montserrat">Montserrat</option>
                                            <option value="Morocco">Morocco</option>
                                            <option value="Mozambique">Mozambique</option>
                                            <option value="Myanmar">Myanmar</option>
                                            <option value="Namibia">Namibia</option>
                                            <option value="Nauru">Nauru</option>
                                            <option value="Nepal">Nepal</option>
                                            <option value="Netherlands">Netherlands</option>
                                            <option value="Netherlands Antilles">Netherlands Antilles</option>
                                            <option value="New Caledonia">New Caledonia</option>
                                            <option value="New Zealand">New Zealand</option>
                                            <option value="Nicaragua">Nicaragua</option>
                                            <option value="Niger">Niger</option>
                                            <option value="Nigeria">Nigeria</option>
                                            <option value="Niue">Niue</option>
                                            <option value="Norfolk Island">Norfolk Island</option>
                                            <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                            <option value="Norway">Norway</option>
                                            <option value="Oman">Oman</option>
                                            <option value="Pakistan">Pakistan</option>
                                            <option value="Palau">Palau</option>
                                            <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                                            <option value="Panama">Panama</option>
                                            <option value="Papua New Guinea">Papua New Guinea</option>
                                            <option value="Paraguay">Paraguay</option>
                                            <option value="Peru">Peru</option>
                                            <option value="Philippines">Philippines</option>
                                            <option value="Pitcairn">Pitcairn</option>
                                            <option value="Poland">Poland</option>
                                            <option value="Portugal">Portugal</option>
                                            <option value="Puerto Rico">Puerto Rico</option>
                                            <option value="Qatar">Qatar</option>
                                            <option value="Reunion">Reunion</option>
                                            <option value="Romania">Romania</option>
                                            <option value="Russian Federation">Russian Federation</option>
                                            <option value="Rwanda">Rwanda</option>
                                            <option value="Saint Helena">Saint Helena</option>
                                            <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                            <option value="Saint Lucia">Saint Lucia</option>
                                            <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                                            <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                                            <option value="Samoa">Samoa</option>
                                            <option value="San Marino">San Marino</option>
                                            <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                            <option value="Saudi Arabia">Saudi Arabia</option>
                                            <option value="Senegal">Senegal</option>
                                            <option value="Serbia and Montenegro">Serbia and Montenegro</option>
                                            <option value="Seychelles">Seychelles</option>
                                            <option value="Sierra Leone">Sierra Leone</option>
                                            <option value="Singapore">Singapore</option>
                                            <option value="Slovakia">Slovakia</option>
                                            <option value="Slovenia">Slovenia</option>
                                            <option value="Solomon Islands">Solomon Islands</option>
                                            <option value="Somalia">Somalia</option>
                                            <option value="South Africa">South Africa</option>
                                            <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich Islands</option>
                                            <option value="Spain">Spain</option>
                                            <option value="Sri Lanka">Sri Lanka</option>
                                            <option value="Sudan">Sudan</option>
                                            <option value="Suriname">Suriname</option>
                                            <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                                            <option value="Swaziland">Swaziland</option>
                                            <option value="Sweden">Sweden</option>
                                            <option value="Switzerland">Switzerland</option>
                                            <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                            <option value="Taiwan">Taiwan</option>
                                            <option value="Tajikistan">Tajikistan</option>
                                            <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                                            <option value="Thailand">Thailand</option>
                                            <option value="Timor-leste">Timor-leste</option>
                                            <option value="Togo">Togo</option>
                                            <option value="Tokelau">Tokelau</option>
                                            <option value="Tonga">Tonga</option>
                                            <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                            <option value="Tunisia">Tunisia</option>
                                            <option value="Turkey">Turkey</option>
                                            <option value="Turkmenistan">Turkmenistan</option>
                                            <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                            <option value="Tuvalu">Tuvalu</option>
                                            <option value="Uganda">Uganda</option>
                                            <option value="Ukraine">Ukraine</option>
                                            <option value="United Arab Emirates">United Arab Emirates</option>
                                            <option value="United Kingdom">United Kingdom</option>
                                            <option value="United States">United States</option>
                                            <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                                            <option value="Uruguay">Uruguay</option>
                                            <option value="Uzbekistan">Uzbekistan</option>
                                            <option value="Vanuatu">Vanuatu</option>
                                            <option value="Venezuela">Venezuela</option>
                                            <option value="Viet Nam">Viet Nam</option>
                                            <option value="Virgin Islands, British">Virgin Islands, British</option>
                                            <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                                            <option value="Wallis and Futuna">Wallis and Futuna</option>
                                            <option value="Western Sahara">Western Sahara</option>
                                            <option value="Yemen">Yemen</option>
                                            <option value="Zambia">Zambia</option>
                                            <option value="Zimbabwe">Zimbabwe</option>
                                        </select>` +
        `</div>` +
        `<input type="text" id="lifer__product-${object.id}" value="${object.product_title}" required="" name="product" maxlength="100" class="lifer-input input-full rfield" placeholder="Product*" disabled>` +
        `<input type="text" id="lifer__serial-${object.id}" value="${object.serial_number}" required="" name="serial_number" maxlength="100" class="lifer-input input-full rfield" placeholder="Serial number*" disabled>` +
        `<input type="submit" class="lifer-update-btn lifer-submit button button--primary button--fixed" value="Update">` +
        `<input type="submit" class="lifer-delete-btn lifer-submit button button--secondary button--fixed" value="Delete">` +
        '</div>' +
        '</div>');

    $('.lifers').append(form);

    $(".lifer_account-datepicker").each(function(i, value) {
        $(this).datepicker({
            maxDate: '0',
            changeYear: true,
            yearRange: '-100:+0',
            changeMonth: true,
            dateFormat: "mm-dd-yy",
            setDate: $(this).attr("value")
        });
    });
}

function validateSerialNumber(num){
    let pattern = /[0-9]{4}ER[0-9]{5}/i,
        r = num.val();
    if (!pattern.test(r)) {
        $('.serial-message').html('Invalid serial number!').show();
        return false;
    } else{
        $('.serial-message').html('').hide();
        return true;
    }
}

var ajaxData = (function(module, $) {
    'use strict';
    var init, buildTable, orderRequestTable, buildTableBikeRegistrations, getMonthName;
    var $referralContainer = $('#referralContainer');
    var $bikeRegistrationsContainer = $('#bikeRegistrationsContainer');
    var $orderRequestContainer = $('#orderRequestContainer');
    var actionUrl = window.theme.routes.shop_url.permanent_domain == 'early-rider-us.myshopify.com' || window.theme.routes.permanent_domain == 'liferbikes-test.myshopify.com' ? `${window.theme.routes.shop_url}/a/early-rider-preprod` : `${window.theme.routes.shop_url}/a/early-rider`;

    init = function() {
        

        $.ajax({
            url:     actionUrl + '/bike-registrations',
            type:    'POST',
            data:    {
                email: `${window.theme.customer.email}`
            },
            success: function (result) {
                buildTableBikeRegistrations(result);
            },
            error:   function (XMLHttpRequest, textStatus, result) {
                //console.log(result);
            }
        });

        $('body').on('click', '.referral__load-more', function(e){
            e.preventDefault();
            $(this).hide().parent().find('table tbody tr:nth-child(n+4)').show();
        });
    };
    getMonthName = function(num) {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[num];
    };

    orderRequestTable = function(response) {
        $orderRequestContainer.empty();
        if (response.errors.length > 0 || response.orders.length == 0) {
            //console.log("Request Failed: " + response.errors.join(', '));
            var errorsStr = (response.orders.length == 0 || response.errors[0] == 'Customer not found') ? 'You haven\'t placed any order requests yet.' : 'Request Failed: ' + response.errors.join(', ');
            $orderRequestContainer.append('<p class="referral-error">' + errorsStr + '</p>');
            return;
        }
        var items = [],
            item = {},
            data = {},
            source = $('#orderRequestTemplate').html(),
            template = Handlebars.compile(source);
        $.each(response.orders, function(index, dataItem) {
            var dateCreated =  new Date(dataItem.created_at.slice(0,10));
            var dateFormatCreated = dateCreated.getDate() + ' ' + getMonthName(dateCreated.getMonth()) + ', ' + dateCreated.getFullYear();
            item = {
                number: dataItem.order_number,
                date: dateFormatCreated,
                status: dataItem.status != null ? dataItem.status : null,
                total: dataItem.total_price != null ? theme.Currency.formatMoney((dataItem.total_price * 100), theme.strings.moneyFormat) : null
            };
            items.push(item);
        });
        data = {
            items: items,
            showLoadMore: response.orders.length > 3 ? true : false
        };
        $orderRequestContainer.prev().removeClass('hide');
        $orderRequestContainer.append(template(data));
    };
    buildTable = function(response) {
        $referralContainer.empty();
        if (response.errors.length > 0 || response.orders.length == 0) {
            //console.log("Request Failed: " + response.errors.join(', '));
            var errorsStr = (response.orders.length == 0 || response.errors[0] == 'Customer not found') ? 'No referral orders yet' : 'Request Failed: ' + response.errors.join(', ');
            $referralContainer.append('<p class="referral-error">' + errorsStr + '</p>');
            return;
        }
        var items = [],
            item = {},
            data = {},
            source = $('#referralTemplate').html(),
            template = Handlebars.compile(source);
        $.each(response.orders, function(index, dataItem) {
            var dateCreated =  new Date(dataItem.created_at.slice(0,10));
            var dateFormatCreated = dateCreated.getDate() + ' ' + getMonthName(dateCreated.getMonth()) + ', ' + dateCreated.getFullYear();
            item = {
                number: dataItem.order_number,
                date: dateFormatCreated,
                itemId: dataItem.id,
                paymentStatus: dataItem.financial_status != null ? dataItem.financial_status : null,
                fulfillmentStatus: dataItem.fulfillment_status != null ? dataItem.fulfillment_status : 'Unfulfilled',
                name: dataItem.customer.first_name + ' ' + dataItem.customer.last_name,
                meta_info: dataItem.meta_info.join(', '),
                api_id: dataItem.api_id,
                token: dataItem.token
            };
            items.push(item);
        });
        data = {
            items: items,
            showLoadMore: response.orders.length > 3 ? true : false
        };
        $referralContainer.prev().removeClass('hide');
        $referralContainer.append(template(data));
    };
    buildTableBikeRegistrations = function(response) {
        $bikeRegistrationsContainer.empty();
        if (response.errors.length > 0 || response.bikeRegistrations.length == 0) {
            //console.log("Request Failed: " + response.errors.join(', '));

            let emptyFormMsg = 'You haven’t registered any bikes yet. Please visit our Bike Registration page.';
            if (theme.bike_registrations && theme.bike_registrations.empty_form != '') {
                emptyFormMsg = theme.bike_registrations.empty_form;
            }

            var errorsStr = (response.bikeRegistrations.length == 0 || response.errors[0] == 'Customer not found') ? emptyFormMsg : 'Request Failed: ' + response.errors.join(', ');
            $bikeRegistrationsContainer.append('<div class="referral-error">' + errorsStr + '</div>');
            return;
        }
        var items = [],
            item = {},
            data = {},
            source = $('#bikeRegistrationsTemplate').html(),
            template = Handlebars.compile(source);
        $.each(response.bikeRegistrations, function(index, dataItem) {
            var dateCreated =  new Date(dataItem.purchased_at.slice(0,10));
            var dateFormatCreated = getMonthName(dateCreated.getMonth()) + ', ' + dateCreated.getFullYear();
            item = {
                date: dateFormatCreated,
                model: dataItem.model,
                serialNumber: dataItem.serial_number == null ? '&mdash;': dataItem.serial_number
            };
            items.push(item);
        });
        data = {
            items: items,
            showLoadMore: response.bikeRegistrations.length > 3 ? true : false
        };
        $bikeRegistrationsContainer.prev().removeClass('hide');
        $bikeRegistrationsContainer.append(template(data));
    };
    module = {
        init: init
    };
    return module;
})(ajaxData || {}, jQuery);
ajaxData.init();